import deepmerge from 'deepmerge'
import TimedStorage from './timed-storage.js'

function initializeVuexVarsFromLocalStorage (app, variables, setupListeners = true) {
  const keys = Object.keys(variables)
  const keySet = new Set()
  const mutationMap = {}
  const timedStorage = new TimedStorage(localStorage)

  Object.entries(variables).forEach(([key, value]) => {
    const { mutation } = value
    const finalMutation = mutation || key
    keySet.add(finalMutation)
    mutationMap[finalMutation] = key
  })

  keys.forEach(key => {
    const entry = variables[key]
    const { type, default: defaultVal, action, check = () => true, duration } = entry
    let rawVal
    if (duration) {
      rawVal = timedStorage.getItem(key)
    } else {
      rawVal = localStorage.getItem(key)
    }
    let val = defaultVal || app.$store.getters[key]
    if (rawVal !== null) {
      switch (type) {
        case Boolean:
          val = rawVal === 'true'
          break
        case Number:
          val = Number(rawVal)
          break
        case Object: {
          const defaultVal = app.$store.getters[key]
          try {
            val = deepmerge(defaultVal, JSON.parse(rawVal))
          } catch (e) {
          }
          const newRawVal = JSON.stringify(val)
          if (newRawVal !== rawVal) {
            if (duration) {
              timedStorage.setItem(key, newRawVal, duration)
            } else {
              localStorage.setItem(key, newRawVal)
            }
          }
          break
        }
        case Array: {
          val = JSON.parse(rawVal)
          break
        }
        case String:
          val = rawVal
          break
      }
    }
    if (check({ app })) {
      try {
        if (action) {
          app.$store.dispatch(action, val)
        } else {
          app.$store.commit(key, val)
        }
      } catch (e) {
        // Probably a missing mutation/action
        // Delete this property
        localStorage.removeItem(key)
      }
    }
  })
  if (!setupListeners) {
    return
  }
  // Now, subscribe for changes
  app.$store.subscribe((mutation, state) => {
    const { type: key, payload } = mutation
    if (!keySet.has(key)) {
      return
    }
    const mutationKey = mutationMap[key]
    const entry = variables[mutationKey]
    const val = payload
    const { type, duration } = entry
    switch (type) {
      case Array:
      case Object:
        // Handled by  our deep watcher
        return
    }
    if (duration) {
      timedStorage.setItem(mutationKey, val, duration)
    } else {
      localStorage.setItem(mutationKey, val)
    }
  })

  // Now watch objects for deep changes
  keys.forEach(key => {
    const entry = variables[key]
    const { type, module, duration } = entry
    if (type !== Object && type !== Array) {
      return
    }
    const fn = (state) => {
      if (module) {
        return state[module][key]
      }
      return state[key]
    }
    app.$store.watch(fn, newVal => {
      if (duration) {
        timedStorage.setItem(key, JSON.stringify(newVal), duration)
      } else {
        localStorage.setItem(key, JSON.stringify(newVal))
      }
    }, { deep: true })
  })
}

export default initializeVuexVarsFromLocalStorage
